module.exports = __webpack_public_path__ + "static/media/ic_nav_back.e030335c.svg";